
// Module
import routes from './routes';

export default angular.module( 'app.termsOfService.module',
    [] )
    .config(routes)
    .name



/** WEBPACK FOOTER **
 ** ./src/guest/termsOfService/index.js
 **/